// SHIPPING FILTER  ACTIONS:
export const SET_FROM_MAPPING           = "SET_FROM_MAPPING";
export const SET_RESOURCES_LIST         = "SET_RESOURCES_LIST";
export const UPDATE_FROM_MAPPING_FIELDS ="UPDATE_FROM_MAPPING_FIELDS";
export const REMOVE_FROM_MAPPING_FIELD  = "REMOVE_FROM_MAPPING_FIELD";
export const SET_TO_PAGES               = "SET_TO_PAGES";
export const SET_TO_MAPPING             = "SET_TO_MAPPING";
export const UPDATE_TO_MAPPING_FIELDS   = "UPDATE_TO_MAPPING_FIELDS";
export const REMOVE_TO_MAPPING_FIELD    = "REMOVE_TO_MAPPING_FIELD";
export const SET_TO_PAGE_CONDITION      = "SET_TO_PAGE_CONDITION";
export const CLEAR_PAGES_CONFIG         = "CLEAR_PAGES_CONFIG";
export const ADD_PENDING_DELETED_VARIABLE = "ADD_PENDING_DELETED_VARIABLE";
export const CLEAR_PENDING_DELETED_VARIABLES = "CLEAR_PENDING_DELETED_VARIABLES";
export const REMOVE_TO_PAGES            = "REMOVE_TO_PAGES";
export const UPDATE_TO_PAGE             = "UPDATE_TO_PAGE";

export const LOAD_CONFIG_COLLECTION     = "LOAD_CONFIG_COLLECTION";
export const LOAD_CONFIG_COLLECTION_SILENT = "LOAD_CONFIG_COLLECTION_SILENT";
export const SET_ACTIVE_CONFIG_PAGE     = "SET_ACTIVE_CONFIG_PAGE";
export const REMOVE_ACTIVE_POPUP_PAGE   = "REMOVE_ACTIVE_POPUP_PAGE";
export const SET_RESOURCES_LIST_BY_TYPE = "SET_RESOURCES_LIST_BY_TYPE";
export const UPDATE_PAGE_FLOWS_DATA     = "UPDATE_PAGE_FLOWS_DATA";
export const RESTORE_PAGE_FLOWS         = "RESTORE_PAGE_FLOWS";

export const SET_HISTORY_PAGE_FLOWS     = "SET_HISTORY_PAGE_FLOWS";
export const GO_TO_HISTORY_PAGE_FLOWS   = "GO_TO_HISTORY_PAGE_FLOWS";
export const CLEAR_HISTORY_PAGE_FLOWS   = "CLEAR_HISTORY_PAGE_FLOWS";
export const UPDATE_PAGE_DATA_BY_KEY    = "UPDATE_PAGE_DATA_BY_KEY";
export const REMOVE_HISTORY_PAGE_BY_KEY = "REMOVE_HISTORY_PAGE_BY_KEY";
// export const LOAD_CONFIG_COLLECTION     = "LOAD_CONFIG_COLLECTION";
export const SET_WINDOW_VARIABLE_LIST   = "SET_WINDOW_VARIABLE_LIST";
export const RESET_PAGES_RUNTIME_CACHE  = "RESET_PAGES_RUNTIME_CACHE";
export const SET_PAGES_CONFIG_LOAD_ERROR = "SET_PAGES_CONFIG_LOAD_ERROR";
export const CLEAR_PAGES_CONFIG_LOAD_ERROR = "CLEAR_PAGES_CONFIG_LOAD_ERROR";
